import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--marker-peach)";

export default function IconAvatarAccessoryHeart({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="10" height="10" viewBox="0 0 10 10" fill="none">
            <circle fill={fill} cx="5" cy="5" r="5"/>
            <path fill="#fff" fill-rule="evenodd" clip-rule="evenodd" d="M3.56 6.559c-.428-.112-.814-.413-1.05-.874-.452-.882-.18-2.011.607-2.521.647-.42 1.44-.288 1.952.261.513-.55 1.306-.68 1.953-.261.787.51 1.059 1.639.607 2.521-.236.461-.623.762-1.05.874l-1.51.524-1.51-.524z"/>
        </svg>
    );
}
